export const getSource = () => {
  if (window.todesktop) {
    return 'desktop';
  }
  if (window.ReactNativeWebView) {
    return 'native';
  }
  return 'web';
};
